<div *ngIf="param!='OK'">
    <h1>{{param}}</h1>
</div>

<div *ngIf="param=='OK'">
    <h1>Bienvenido a Hys</h1>
</div>